import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 등록 확인 실패 😥 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 조합지분 판매 등록이 확인되지 않았어요.")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 다시 확인해주세요! ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 다시 등록하기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        style: {"flex-direction":"column"},
        dp: "flex",
        height: "100%",
        "justify-content": "center",
        "align-items": "center",
        my: "90px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            "margin-bottom": "24px",
            "text-align": 'center',
            typography: 'tit18b'
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            "text-align": 'center',
            color: 'gray2',
            typography: 'main16r'
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_footer, {
        p: "20px",
        mb: "safeAreaBottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            dp: "flex",
            gap: "sp6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                corner: "10px",
                width: "100%",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'다시 등록하기'});_ctx.setOpen()})
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}